const float EDGE_SHARPNESS = 10.0;
      const float DAY_BIAS       = 0.0;

      uniform sampler2D u_dayTexture;
      uniform sampler2D u_nightTexture;
      uniform sampler2D u_normalTexture;
      uniform sampler2D u_specTexture;
      uniform sampler2D u_cloudTexture;
      uniform vec3     u_atmosphereColor;
      uniform float    u_atmosphereStrength;
      uniform float    u_cloudShadeStrength;
      uniform float    u_cloudBrightness;
      uniform float    u_cloudOpacity;

      varying vec2  vUv;
      varying vec3  vWorldPos;
      varying vec3  vPosition;
      varying mat3  vTbn;
      
      void main() {
        vec3 sunDir = normalize(-vWorldPos);
        vec3 dayCol   = texture2D(u_dayTexture, vUv).rgb;
        vec3 nightCol = texture2D(u_nightTexture, vUv).rgb;
        float cosA    = dot(normalize(vTbn * (texture2D(u_normalTexture, vUv).xyz * 1.2 - 0.6)), sunDir);
        float mixAmt  = 1.0 / (1.0 + exp(-EDGE_SHARPNESS * (cosA + DAY_BIAS)));
        vec3 base = mix(nightCol, dayCol, mixAmt);

        vec3 tnorm    = texture2D(u_normalTexture, vUv).xyz * 1.2 - 0.6;
        vec3 N        = normalize(vTbn * tnorm);
  
        float reflR   = texture2D(u_specTexture, vUv).r * 0.3 + 0.1;
        vec3 R        = reflect(-sunDir, N);
        vec3 V        = normalize(-vPosition);
        float spec    = clamp(dot(R, V), 0.0, 1.0);
        base         += mixAmt * pow(spec, 2.0) * reflR;

        vec4 cldTex = texture2D(u_cloudTexture, vUv);
        float lum   = (cldTex.r + cldTex.g + cldTex.b) * 0.3333;
        float side  = smoothstep(0.1, -0.1, dot(normalize(vTbn * tnorm), sunDir));
        float b     = mix(u_cloudBrightness, u_cloudBrightness * 0.1, side);
        float o     = mix(u_cloudOpacity, u_cloudOpacity * 0.1, side);
        float shade = mix(1.0, 1.0 - u_cloudShadeStrength, side);
        vec3  bright= mix(cldTex.rgb * shade, vec3(1.0), b);
        base = mix(base, bright, lum * o);

        float hor   = smoothstep(-0.1, 0.1, dot(normalize(vTbn * tnorm), sunDir));
        base       = mix(base, u_atmosphereColor, hor * u_atmosphereStrength);
        gl_FragColor = vec4(base, 1.0);
      }